module.exports = "<!-- LOADING -->\r\n<div class=\"selection-mark checkmark\" *ngIf=\"status == 1\">\r\n  <div class=\"target-poin\"></div>\r\n</div>\r\n\r\n<!-- COMPLETED -->\r\n<div class=\"selection-mark\" *ngIf=\"status == 2\">\r\n  <i class=\"fa fa-check-circle\"></i>\r\n</div>\r\n\r\n<!-- INACTIVE -->\r\n<div class=\"selection-mark gray\" *ngIf=\"status != 1 && status != 2\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/recomended-section/recomended-section.component.html
// module id = ./src/app/shared/components/recomended-section/recomended-section.component.html
// module chunks = main